module.exports = __webpack_public_path__ + "img/Logo.ae9c8dba.png";